<mat-dialog-title class="dialog_title">
    <span>
        {{ "Editing bookmark filter" | translate }}
    </span>
</mat-dialog-title>

<mat-dialog-content class="mat-typography">
    <div class="container form_wrapper bookmarks">

        <form [formGroup]="form" class="form_with_pads form_with_valids">
            <div class="white_block">
                <div class="white_block_title">
                    {{ "Preset details" | translate }}
                </div>

                <mat-form-field appearance="standard" class="full_width_form">
                    <ng-container *ngIf="!form.get('name').valid && submited">
                        <div class="req_field"></div>
                        <div class="req_label">
                            <div class="angle"></div>
                            <span>
                                {{ "You need to write here" | translate }}
                            </span>
                        </div>
                    </ng-container>
                    <mat-label>{{ 'Preset title' | translate }}</mat-label>
                    <input formControlName="name" matInput placeholder="{{ 'Name' | translate }}">
                </mat-form-field>
        
                <mat-form-field appearance="standard" class="full_width_form">
                    <mat-label>{{ 'Order' | translate }}</mat-label>
                    <input formControlName="order" matInput required type="number" placeholder="{{ 'Order' | translate }}">
                </mat-form-field>

            </div>

            <!-- <div class="white_block white_expanded" *ngIf="getKeys()">
                <div class="d-f-c" (click)="openFilters()">
                    <div class="white_block_title">
                        {{ "Bookmark filter values" | translate }}
                    </div>

                    <button mat-icon-button>
                        <mat-icon *ngIf="filters">expand_less</mat-icon>
                        <mat-icon *ngIf="!filters">expand_more</mat-icon>
                    </button>
                </div>
                <div class="white_inside" [ngClass]="{'open': filters}">
                    <ng-container *ngIf="getKeys()">
                        <mat-list role="list" class="active_filter" *ngFor="let key of getKeys()">
                            <mat-list-item role="listitem" class="active_filter_item" *ngFor="let val of getValues(activeParams[key])">
                                <div class="d-f-c">
                                    <div class="key text_one_line">{{ key | translate }}:</div>
                                    <div class="val">
                                        <ng-container [ngSwitch]="key">
                                            <ng-container *ngSwitchCase="'o__dayView'">
                                                {{data.dayFilters[val].name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'o__hourView'">
                                                {{data.hourViewsFilters[val].name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'o__realtime'">
                                                {{data.realtimeFilters[val].name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'analytics_id'">
                                                {{data.filters[val].name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'task_created_at_from'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'task_created_at_to'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'task_operation_created_at_from'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'task_operation_created_at_to'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'task_operation_completed_at_from'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'task_operation_completed_at_to'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'discussion_created_at_from'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'discussion_created_at_to'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'file_created_at_from'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'file_created_at_to'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'file_updated_at_from'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'file_updated_at_to'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'file_meta_creation_time_from'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'file_meta_creation_time_to'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'task_channel_published_at_from'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'task_channel_published_at_to'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'created_at_from'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'created_at_to'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'analytics_views_count_from'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'analytics_views_count_to'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'start_at_from'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'start_at_to'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'updated_at_from'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'updated_at_to'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'posted_at_from'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'posted_at_to'">
                                                {{val | reportsDate:data.activeLang}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'operation_status_id'">
                                                {{getStatusById(val)?.name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'status_id'">
                                                {{getStatusById(val)?.name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'doneStatus'">
                                                {{getStatusById(val)?.name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'order_by'">
                                                <div class="d-f-c" style="padding: 0; width: 100%; justify-content: flex-start;">
                                                    {{getOrder(val)?.name}}
                                                    <mat-icon *ngIf="getOrder(val)?.arrow" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                                                    <mat-icon *ngIf="!getOrder(val)?.arrow" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'task_operation_operation_id'">
                                                {{getJobTypeById(val)?.name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'group_id'">
                                                {{getGroupById(val)?.name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'priority'">
                                                {{getPriorityById(val)?.name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'content_status_id'">
                                                {{getProfileStatusByID(val)?.name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'task_status_id'">
                                                {{getTaskStatusById(val)?.name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'is_content_url'">
                                                {{getContentUrlByID(val)?.name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'channel_id'">
                                                <div class="d-f-c" style="padding: 0; width: 100%; justify-content: flex-start;">
                                                    <app-platform [platform_id]="getProfileByID(val)?.platform_id"></app-platform>
                                                    <span class="ml-1 text_one_line">
                                                        {{getProfileByID(val)?.name}}
                                                    </span>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'parameter_value_id'">
                                                {{getValueById(val)?.value}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'task_parameter_value_id'">
                                                {{getValueById(val)?.value}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'task_operation_parameter_value_id'">
                                                {{getValueById(val)?.value}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'discussion_parameter_value_id'">
                                                {{getValueById(val)?.value}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'file_parameter_value_id'">
                                                {{getValueById(val)?.value}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'is_content_views_count_update'">
                                                <ng-container [ngSwitch]="val">
                                                    <ng-container *ngSwitchCase="0">
                                                        {{ "Without auto-update" | translate }}
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="1">
                                                        {{ "With auto-update" | translate }}
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="2">
                                                        {{ "Error in update" | translate }}
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'content_type_id'">
                                                {{getContentById(val)?.name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'views_update_interval'">
                                                {{getViewsUpdateIntervalListByValue(val)?.name}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'created_employee_id'">
                                              <app-user [class]="'user_div'" [employee]="getEmployeeById(val)"></app-user>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'updated_employee_id'">
                                              <app-user [class]="'user_div'" [employee]="getEmployeeById(val)"></app-user>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'created_url_employee_id'">
                                              <app-user [class]="'user_div'" [employee]="getEmployeeById(val)"></app-user>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'updated_url_employee_id'">
                                              <app-user [class]="'user_div'" [employee]="getEmployeeById(val)"></app-user>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'platform_id'">
                                                <div class="d-f-c" style="padding: 0; width: 100%; justify-content: flex-start;">
                                                    <app-platform [platform_id]="val"></app-platform>
                                                    <span class="ml-1 text_one_line">
                                                        {{ getPlatformById(val)?.name }}
                                                    </span>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'channel_platform_id'">
                                                <div class="d-f-c" style="padding: 0; width: 100%; justify-content: flex-start;">
                                                    <app-platform [platform_id]="val"></app-platform>
                                                    <span class="ml-1 text_one_line">
                                                        {{ getPlatformById(val)?.name }}
                                                    </span>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'operation_employee_id'">
                                                <ng-container *ngIf="val == 0; else elseTemplateWithoutExecMobF">
                                                    {{ "Not set" | translate }} 
                                                </ng-container>
                                                <ng-template #elseTemplateWithoutExecMobF>
                                                    <app-user [class]="'user_div'" [employee]="getEmployeeById(val)"></app-user>
                                                </ng-template>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'client_employee_id'">
                                                <ng-container *ngIf="val == 0; else elseTemplateWithoutClientMobF">
                                                    {{ "Not set" | translate }} 
                                                </ng-container>
                                                <ng-template #elseTemplateWithoutClientMobF>
                                                    <app-user [class]="'user_div'" [employee]="getEmployeeById(val)"></app-user>
                                                </ng-template>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'operation_partner_company_id'">
                                                <ng-container *ngIf="val == 0; else elseTemplateWithoutClientMobF">
                                                    {{ "Not set" | translate }} 
                                                </ng-container>
                                                <ng-template #elseTemplateWithoutClientMobF>
                                                    <app-user [class]="'user_div ml-1'" [companyEmployee]="getPartnerById(val)?.partnerCompany" [imgRoute]="data.imgRoute" [host]="data.host" [company]="data.company"></app-user>
                                                </ng-template>
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{ val }}
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="remove" (click)="getValues(activeParams[key]).length > 1 ? removeValue(key, val) : removeValue(key)">
                                    <mat-icon>close</mat-icon>
                                </div>
                            </mat-list-item>
                            <mat-list-item *ngIf="getValues(activeParams[key]).length > 1" class="remove_all" (click)="removeValue(key)" role="listitem">Remove all</mat-list-item>
                        </mat-list>
                    </ng-container>
                </div>
            </div> -->
        </form>

    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="f_w_p_btns">
        <button mat-button (click)="close()">
            {{ "Close" | translate }}
        </button>
        <button class="ml-1 d-f-btn" (click)="save()" mat-raised-button cdkFocusInitial color="primary" [disabled]="!!isSubmit">
            <mat-spinner class="spin_16 mr-1" *ngIf="isSubmit"></mat-spinner>  
            {{ "Save" | translate }}
        </button>
    </div>
</mat-dialog-actions>
